import React from 'react';
import styled, { css } from 'styled-components';
import { trackButtonClick } from '../../firebase/trackingService';

const ButtonStyles = styled.button`
  padding: ${props => props.size === 'large' ? '16px 32px' : '12px 24px'};
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: ${props => props.size === 'large' ? '18px' : '16px'};
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: none;
  
  ${props => props.variant === 'primary' && css`
    background-color: #00C853; /* Emerald green */
    color: #FFFFFF;
    
    &:hover {
      background-color: #00B248;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 200, 83, 0.3);
    }
  `}
  
  ${props => props.variant === 'secondary' && css`
    background-color: #2196F3; /* Electric blue */
    color: #FFFFFF;
    
    &:hover {
      background-color: #1976D2;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(33, 150, 243, 0.3);
    }
  `}
  
  ${props => props.variant === 'tertiary' && css`
    background-color: transparent;
    color: #2196F3;
    border: 2px solid #2196F3;
    
    &:hover {
      background-color: rgba(33, 150, 243, 0.1);
      transform: translateY(-2px);
    }
  `}
  
  ${props => props.variant === 'gold' && css`
    background-color: #FFD700; /* Rich gold */
    color: #121212;
    
    &:hover {
      background-color: #FFC400;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(255, 215, 0, 0.3);
    }
  `}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
  }
`;

/**
 * Button component with Firebase tracking
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  onClick,
  id,
  sectionName = 'unknown',
  disabled = false,
  type = 'button',
  additionalData = {},
  ...props
}) => {
  const handleClick = (e) => {
    // Track the button click
    if (!disabled) {
      trackButtonClick(
        id || `${variant}-button`, 
        children.toString(), 
        sectionName,
        additionalData
      );
      
      // Call the original onClick handler if provided
      if (onClick) onClick(e);
    }
  };

  return (
    <ButtonStyles
      type={type}
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </ButtonStyles>
  );
};

export default Button;
